<script setup>
const { t } = useI18n();
const route = useRoute();

import { pageTransition } from '~/helpers/animations/animations';

definePageMeta({
  pageTransition: pageTransition,
});

const pageQuery = gql`
  query GetPageData($routeId: String!) {
    page(route_id: $routeId) {
      seo_meta_title
      seo_meta_description
      seo_meta_keywords
      name
      content
    }
    contactGroups {
      id
      name
      contacts {
        id
        name
        job
        slug: seo_url_slug {
          cs
          en
        }
        image
        group {
          name
        }
        building {
          id
          name
          slug: seo_url_slug {
            cs
            en
          }
        }
      }
    }
  }
`;

const { data } = await useAsyncQuery(pageQuery, {
  routeId: route.name,
});

const page = computed(() => data.value?.page);
const groups = computed(() => data.value?.contactGroups.filter((x) => x.contacts.length));

const breadcrumbs = ref([
  {
    title: t('pages.about.index.breadcrumbs-title'),
    route: 'about',
  },
  { title: t('pages.people.index.breadcrumbs-title') },
]);

useHeadData({
  title: page.value?.seo_meta_title || page.value?.name || t('pages.people.index.breadcrumbs-title'),
  description: page.value?.seo_meta_description || null,
  keywords: page.value?.seo_meta_keywords || null,
  image: page.value?.image_detail || page.value?.cropped_detail_image || null,
  url: route.fullPath,
});
</script>

<template>
  <main class="main">
    <div class="people">
      <Breadcrumbs :items="breadcrumbs" />
      <div v-if="page" class="container-max-content">
        <h1 class="heading">{{ page.name }}</h1>
        <DynamicPageContent v-if="page.content" :content="page.content" class="mt-5" />

        <div v-for="(group, groupKey) in groups" :key="groupKey" class="people__section mt-5">
          <ContactList v-if="group.contacts.length" :contacts="group.contacts" :groupNames="true" />
        </div>
      </div>
    </div>
  </main>
</template>

<style lang="scss" scoped>
.people {
  &__section {
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__section-title {
    margin-bottom: 40px;
  }
}
</style>
